import { useGlobalConfigContext } from '../../../../global-config'
import { TENANT } from '../../../../tenant'
import { PRODUCT_TEMPLATES } from '../../../model/productTemplates'
import { useProductPageContext } from '../../productPageContext'

const PRODUCT_BUY_BOX_DELIVERY_DATES_TENANTS = new Set<TENANT>([
  TENANT.CH,
  TENANT.COM,
  TENANT.FR,
  TENANT.IT,
])

export const useShowProductDeliveryDates = (): boolean => {
  const { tenant } = useGlobalConfigContext()
  const { product, productTemplate } = useProductPageContext()

  const inventoryWithoutExcludedLevels = product.offers?.[0]?.inventory?.filter(
    (item) => item.level !== undefined && item.level !== -1,
  )

  const isOTProduct =
    (productTemplate === PRODUCT_TEMPLATES.OTC ||
      productTemplate === PRODUCT_TEMPLATES.OTX) &&
    Boolean(inventoryWithoutExcludedLevels?.length)

  return isOTProduct && PRODUCT_BUY_BOX_DELIVERY_DATES_TENANTS.has(tenant)
}
